<template>
    <dashboard-filter
      :is-disabled="isDisabled"
      @change="emitHandler">
      <option value="0">{{$t('ui.dashboard.active_leads.today')}}</option>
      <option value="7" selected>{{$t('ui.dashboard.active_leads.last_7')}}</option>
      <option value="31">{{$t('ui.dashboard.active_leads.last_month')}}</option>
      <option value="365">{{$t('ui.dashboard.active_leads.last_year')}}</option>
      <option :value="all">{{$t('ui.dashboard.active_leads.all_time')}}</option>
    </dashboard-filter>
</template>

<script>
import moment from 'moment'

import DashboardFilter from './DashboardFilter'
import FilterMixin from './mixins/FilterMixin'

export default {
  mixins: [FilterMixin],

  components: {
    DashboardFilter
  },

  computed: {
    all: {
      get () {
        // Day when Leads has been founded
        return moment().diff(moment('20170101'), 'days') + 1
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// PeriodFilter.vue?0affd6e8